import { Component, OnInit } from '@angular/core';
import { SharedConfig } from '@takectrl-multiapp/svcs-share-config';
import { BUSNCommunicationService } from 'libs/svcs-core-business/src/lib/services/busn-communication.service';

@Component({
  selector: 'popup-with-chat-button',
  standalone: false,
  templateUrl: './popup-with-chat-button.component.html',
  styleUrls: ['./popup-with-chat-button.component.scss'],
})
export class PopupWithChatButtonComponent implements OnInit {
  constructor(public sharedConfig: SharedConfig, private readonly busnCommService: BUSNCommunicationService) {}

  ngOnInit(): void {}

  openChat() {
    this.busnCommService.openContactCardPopup()
    this.dismiss();
  }

  dismiss() {
    SharedConfig.showPopupWithChat = false;
    SharedConfig.showFullScreen = false;
    SharedConfig.headerForPopupWithChat = '';
    SharedConfig.messageForPopupWithChat = '';
  }
}
